import { render, staticRenderFns } from "./AsMainReservedSubList.vue?vue&type=template&id=314f0cd1"
import script from "./AsMainReservedSubList.vue?vue&type=script&lang=js"
export * from "./AsMainReservedSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports